import { render, staticRenderFns } from "./multipleFile2.vue?vue&type=template&id=3bcd1d84&"
import script from "./multipleFile2.vue?vue&type=script&lang=js&"
export * from "./multipleFile2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports